import { Component, OnInit, ViewChildren, AfterViewInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { AppdataService } from 'src/app/services/services/appdata.service';
import { LoginserviceService } from 'src/app/services/services/loginservice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-addscheduletemplate',
  templateUrl: './addscheduletemplate.component.html',
  styleUrls: ['./addscheduletemplate.component.css']
})
export class AddscheduletemplateComponent implements OnInit {



  formname:String="ScheduleTemplate";
  //Display
  formmode:string="Add";
  
   //Mode Values
   isaddmode:boolean=false;
   iseditmode:boolean=false;
   isdeletemode:boolean=false;
   isviewmode:boolean=false;
  
  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  
   //Save Validation
   submitted:boolean;
   successfully:boolean;
   saveloading: boolean;

   //Edit Get Values
   
   scheduletempColl:any=[];
   scheduletempBO:any={};
   scheduletempid:number=0
   
   scheduletempform=new FormGroup({
    
    scheduletempid:new FormControl(0),          
    scheduletempname:new FormControl('',Validators.required),
     descr:new FormControl(''),
     starttime:new FormControl(null),
     endtime:new FormControl(null),
    sun1:new FormControl(''),
    mon1:new FormControl(''),
    tue1:new FormControl(''),
    wed1:new FormControl(''),
    thu1:new FormControl(''),
    fri1:new FormControl(''),
    sat1:new FormControl(''),
    sun2:new FormControl(''),
    mon2:new FormControl(''),
    tue2:new FormControl(''),
    wed2:new FormControl(''),
    thu2:new FormControl(''),
    fri2:new FormControl(''),
    sat2:new FormControl(''),
    sun3:new FormControl(''),
    mon3:new FormControl(''),
    tue3:new FormControl(''),
    wed3:new FormControl(''),
    thu3:new FormControl(''),
    fri3:new FormControl(''),
    sat3:new FormControl(''),
    sun4:new FormControl(''),
    mon4:new FormControl(''),
    tue4:new FormControl(''),
    wed4:new FormControl(''),
    thu4:new FormControl(''),
    fri4:new FormControl(''),
    sat4:new FormControl(''),
    sun5:new FormControl(''),
    mon5:new FormControl(''),
    tue5:new FormControl(''),
    wed5:new FormControl(''),
    thu5:new FormControl(''),
    fri5:new FormControl(''),
    sat5:new FormControl(''),
    inactive:new FormControl(false),  
   });
  
  
  constructor(private appService: AppdataService,private loginService:LoginserviceService,private route: ActivatedRoute,
      public router: Router,private toastr: ToastrService, private productFindService: NgbModal) { 
        this.route.queryParams.subscribe(params => {
          if(params.id!==undefined){
            this.scheduletempid = params.id
          }          
        });
  
        this.fnServiceChanges();
  }
  
    
  fnServiceChanges() {
    this.loginService.serviceAuthChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.fnUserFailedForm();
      }
  
    });
  }
  
  
  
  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
  
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }
  
  fnOnInitForm() {
      try{
          this.isaddmode=true;
          this.scheduletempform.reset();
          this.fnInitializeFormGroup(); 
  
          if(this.scheduletempid>0){
            this.fngetScheduleTemp();
            }
         
      }catch(ex){
        this.fnShowErrorMsg(ex);
      }
  
  }
  ngAfterViewInit()
{
  this.loginService.fnSetFirstControlFocus('txtfirst');
}
  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.scheduletempid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }
  
    return _check;
  }
  
  fnUserFailedForm() {
    this.isprivilage = true;
  }
  
  
  fnInitializeFormGroup(){
      this.scheduletempform.setValue({
        scheduletempid:0,
      
        scheduletempname:'',
        descr:'',
        starttime:'',
        endtime:'',
        sun1:'WORK',
        mon1:'WORK',
        tue1:'WORK',
        wed1:'WORK',
        thu1:'WORK',
        fri1:'WORK',
        sat1:'WORK',
        sun2:'WORK',
        mon2:'WORK',
        tue2:'WORK',
        wed2:'WORK',
        thu2:'WORK',
        fri2:'WORK',
        sat2:'WORK',
        sun3:'WORK',
        mon3:'WORK',
        tue3:'WORK',
        wed3:'WORK',
        thu3:'WORK',
        fri3:'WORK',
        sat3:'WORK',
        sun4:'WORK',
        mon4:'WORK',
        tue4:'WORK',
        wed4:'WORK',
        thu4:'WORK',
        fri4:'WORK',
        sat4:'WORK',
        sun5:'WORK',
        mon5:'WORK',
        tue5:'WORK',
        wed5:'WORK',
        thu5:'WORK',
        fri5:'WORK',
        sat5:'WORK',
        inactive:false              
      })
  }
  
  
  
  //Get 
  fngetScheduleTemp() {        
        var data = {
          'scheduletempid':this.scheduletempid,
          'companyid':this.loginService.fnGetCompanyId()          
        }
        this.appService.getScheduletemplate(data)
        .subscribe(
          (res)=>{                
            if(res.json().status===200){  
              this.scheduletempColl=res.json().result;
              var editdata = this.scheduletempColl[0];        
              this.fnEditMode(editdata);
              this.scheduletempBO=editdata;
            }
            else {
              this.loginService.fnAPIError(res.json())
            }
            
        },
        (err)=>{          
          this.toastr.error('Error', err);
        })
  }
  
  
  
  //Save Btn Click
  fnSaveBtnClick(){
      try{ if (this.saveloading) {
        return;
      }
        this.submitted=true;
        this.successfully=false;
        //Validate
        if(this.scheduletempform.valid){ this.saveloading = true;
            //Check
            var data = {
                  'scheduletempid': this.scheduletempid,    
                  'scheduletempname':this.scheduletempform.get('scheduletempname').value,
                  'descr':this.scheduletempform.get('descr').value,
                  'starttime':this.scheduletempform.get('starttime').value,
                  'endtime':this.scheduletempform.get('endtime').value,
                  'sun1':this.scheduletempform.get('sun1').value,
                  'sun2':this.scheduletempform.get('sun2').value,
                  'sun3':this.scheduletempform.get('sun3').value,
                  'sun4':this.scheduletempform.get('sun4').value,
                  'sun5':this.scheduletempform.get('sun5').value,
                  'mon1':this.scheduletempform.get('mon1').value,
                  'mon2':this.scheduletempform.get('mon2').value,
                  'mon3':this.scheduletempform.get('mon3').value,
                  'mon4':this.scheduletempform.get('mon4').value,
                  'mon5':this.scheduletempform.get('mon5').value,
                  'tue1':this.scheduletempform.get('tue1').value,
                  'tue2':this.scheduletempform.get('tue2').value,
                  'tue3':this.scheduletempform.get('tue3').value,
                  'tue4':this.scheduletempform.get('tue4').value,
                  'tue5':this.scheduletempform.get('tue5').value,
                  'wed1':this.scheduletempform.get('wed1').value,
                  'wed2':this.scheduletempform.get('wed2').value,
                  'wed3':this.scheduletempform.get('wed3').value,
                  'wed4':this.scheduletempform.get('wed4').value,
                  'wed5':this.scheduletempform.get('wed5').value,
                  'thu1':this.scheduletempform.get('thu1').value,
                  'thu2':this.scheduletempform.get('thu2').value,
                  'thu3':this.scheduletempform.get('thu3').value,
                  'thu4':this.scheduletempform.get('thu4').value,
                  'thu5':this.scheduletempform.get('thu5').value,
                  'fri1':this.scheduletempform.get('fri1').value,
                  'fri2':this.scheduletempform.get('fri2').value,
                  'fri3':this.scheduletempform.get('fri3').value,
                  'fri4':this.scheduletempform.get('fri4').value,
                  'fri5':this.scheduletempform.get('fri5').value,
                  'sat1':this.scheduletempform.get('sat1').value,
                  'sat2':this.scheduletempform.get('sat2').value,
                  'sat3':this.scheduletempform.get('sat3').value,
                  'sat4':this.scheduletempform.get('sat4').value,
                  'sat5':this.scheduletempform.get('sat5').value,
                  'inactive':this.scheduletempform.get('inactive').value,            
                  'companyid':this.loginService.fnGetCompanyId(),
                  'createdby': this.loginService.fnGetModUserId(),  
                 'modifiedby':this.loginService.fnGetModUserId(),                                                              
            }
  
          
            this.appService.fnCheckScheduletemplate(data).subscribe(
              (res)=>{
                if(res.json().status===200){  
                  var _checkresult=res.json().result[0].checkfield;
                
                  if(_checkresult==="done"){
                        if (this.scheduletempform.get('scheduletempid').value>0){
                          //Update 
                          this.fnSetScheduleTemp(data);
                        }
                        else{
                          //Insert 
                          this.fnInsertScheduleTemp(data);
                        }
                  }
                  else {       
                  
                        if(_checkresult==="name"){ this.saveloading = false;

                          this.scheduletempform.controls['scheduletempname'].setErrors({'notfound': true});
                        }
                  }
                }
                else { this.saveloading = false;

                  this.loginService.fnAPIError(res.json())
                }
            },
            (err)=>{ this.saveloading = false;

                this.toastr.error('Error', err);           
            });
         }
      }catch(ex){ this.saveloading = false;console.log(ex)
        this.fnShowErrorMsg(ex);
      }
  }
  
  //Insert
  fnInsertScheduleTemp(data){    
    
      this.appService.fnInsertScheduletemplate(data).subscribe(
        (res)=>{ this.saveloading = false;

          if(res.json().status===200){  
            if(res.json().result!=""){
              this.toastr.success('', "The new Schedule template has been added successfully.Insert Successfully");
              this.fnInsertActivityLog('INSERT', 0, data.scheduletempname);
              this.fnCloseForm();
            }
          }
          else {
            this.loginService.fnAPIError(res.json())
          }
      },
        (err)=>{ this.saveloading = false;

          this.toastr.error('Error', err);
        });
  
  }
  
  //Set
  fnSetScheduleTemp(data){    
  
  this.appService.fnSetScheduletemplate(data).subscribe(
    (res)=>{ this.saveloading = false;

      if(res.json().status===200){  
            if(res.json().result!=""){
                this.toastr.success('', "The scheduletemp has been updated successfully.");
                this.fnInsertActivityLog('EDIT',this.scheduletempid,data.scheduletempname);
                this.fnCloseForm();        
            } 
        }
      else {
        this.loginService.fnAPIError(res.json())
      }
    },
    (err)=>{ this.saveloading = false;

      this.toastr.error('Error', err);
    });
  
  }
  
  
  
  //Close
  fnCloseForm(){
  try{
     this.router.navigate(['/ScheduleTemplate']);
  }catch(ex){
      this.fnShowErrorMsg(ex);
  }
  }
  
    private fnEditMode(deptBO) {
       console.log(deptBO)
    this.scheduletempform.setValue({ 
      scheduletempid:deptBO.scheduletempid,
     
      scheduletempname:deptBO.scheduletempname,
      

      descr:deptBO.descr,starttime:deptBO.starttime,endtime:deptBO.endtime,
      sun1:deptBO.sun1,mon1:deptBO.mon1,tue1:deptBO.tue1,wed1:deptBO.wed1,thu1:deptBO.thu1,fri1:deptBO.fri1,sat1:deptBO.sat1,
      sun2:deptBO.sun2,mon2:deptBO.mon2,tue2:deptBO.tue2,wed2:deptBO.wed2,thu2:deptBO.thu2,fri2:deptBO.fri2,sat2:deptBO.sat2,
      sun3:deptBO.sun3,mon3:deptBO.mon3,tue3:deptBO.tue3,wed3:deptBO.wed3,thu3:deptBO.thu3,fri3:deptBO.fri3,sat3:deptBO.sat3,
      sun4:deptBO.sun4,mon4:deptBO.mon4,tue4:deptBO.tue4,wed4:deptBO.wed4,thu4:deptBO.thu4,fri4:deptBO.fri4,sat4:deptBO.sat4,
      sun5:deptBO.sun5,mon5:deptBO.mon5,tue5:deptBO.tue5,wed5:deptBO.wed5,thu5:deptBO.thu5,fri5:deptBO.fri5,sat5:deptBO.sat5,

      inactive:deptBO.inactive
    });
  
    this.formmode="Edit";
      
    this.iseditmode=true;
    this.isdeletemode=false;
    this.isviewmode=false;
  }
  
  fnInsertActivityLog(action,refno,desc){
    try{
      var data={
        logtype:action,
        logat:this.formname,
        refnum:refno,
        logdescr:desc,companyid: this.loginService.fnGetCompanyId(),         
        logby:this.loginService.fnGetModUserId(),
      }
    
      
  
      this.appService.fnInsertActivity(data).subscribe(
        (res)=>{
        },
        (err)=>{
       
        });
  
    }catch{
  
    }
   }
   private fnShowProgress() {
    this.showProgress = true;
  }
  private fnHideProgress() {
    this.showProgress = false;
  }
  private  fnShowErrorMsg(ex){
  this.toastr.warning('Internal Error', ex);       
  }
  
  
  
  
  
  
  }
  